module.exports = __webpack_public_path__ + "static/media/uparrow.92c863cb.svg";